/* eslint-disable */
import { Component, ChangeDetectorRef, ElementRef, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';

declare var KAMPYLE_ONSITE_SDK: any;

import { ConfirmService } from '../../services/confirm/confirm.service';
import { ModalDialogComponent } from '@vg-constellation/angular-19/modal-dialog';
import { BannerSize, BannerVariant } from '@vg-constellation/angular-19/banner';

import {
  OktaGroups,
  confirmationType,
  confirmationTypeResponse,
  confirmObject, confirmRes,
  selectedValuesObject,
} from '../../models/confirms.model';
import { LoggerService } from '../../services/logger/logger.service';
import { CaasService } from '../../services/caas/caas.service';
import { ConfirmationsPageContent } from '../../models/aem-graphql.model';
import { dropdownObject } from '../../models/caas.model';
import PKG from '../../../../package.json';
import { environment } from '../../../environments/environment';
import moment from 'moment';
import { DropdownMenuData } from '@vg-constellation/angular-19/dropdown';
import { jest } from '@jest/globals';
import { setConfirmationDetails, setStepIndicatorIndex } from '../../state/actions/actions';
import { Store } from '@ngrx/store';
import { Router } from "@angular/router";
import { AVAILABILITY } from '../../util/app.constants';
import { DropdownMenuItem, DropdownState } from '@vg-constellation/angular-19/dropdown';
import { TitleCasePipe } from '@angular/common';
import { StatusUpdateDataTransferService } from '../../services/confirm/status-update-data-transfer.service';
import { CacheConfirmService } from '../../services/confirm/cache-confirm.service';
import { WindowRef } from '@vanguard/secure-site-components-lib';
import { pdfjsLib } from '../../utils/pdfjs-config';

const SCROLLVALUE = 100
const ALL_CONFIRMAION_TYPE = 'All confirmation type'
const ALL_MONTHS = 'All months';
const GRADIENT_LEFT = 'gradient-left';
const GRADIENT_RIGHT = 'gradient-right';
const PDF_MAX_PAGES = 200;
const PDF_MAX_SIZE_MB = 50;
const MOBILE_BREAKPOINT = 768;
const TABLET_BREAKPOINT = 1024;
const MOBILE_SCALE = 2.5;
const TABLET_SCALE = 1.9;
const DESKTOP_SCALE = 1.5;
const PLACEHOLDER_MARGIN_BOTTOM = '15px';

@Component({
    selector: 'app-confirm-page',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss'],
    providers: [TitleCasePipe],
    standalone: false
})
export class ConfirmComponent implements OnInit, AfterViewInit, OnDestroy {

  errorBannerConfig: { size: BannerSize; heading: string; body: string; closable: boolean; collapsible: boolean; type: BannerVariant; variant: BannerVariant } = {
    size: 'medium',
    heading: 'Data unavailable',
    body: 'Our system is temporarily unable to display some of your account information. We apologize for the inconvenience and appreciate your patience while we fix these issues. Please refresh in a few minutes or choose another page.',
    closable: false,
    collapsible: false,
    type: 'error',
    variant: 'warning'
  };
  shouldShowErrorBanner = false;
  shouldShowErrorBannerForNoData = false;
  defaultDropMenuData:DropdownMenuData = {groups: [],};
  isLoaderIndicator = false;
  contentBody: string;
  tetriaryNavigationOptions: Array<dropdownObject>;

  years: string[] = [new Date().getFullYear().toString()];
  months: string[] = [];
  confirmationType: string[] = [ALL_CONFIRMAION_TYPE];
  confirmList: confirmObject[] = [];
  standardConfirmList: confirmObject[] = [];
  filteredMasterConfirmsList: confirmObject[] = [];
  showMoreIndex;
  counter = 0;
  filterOn = false;
  defaultSize = 20;

  selectedValues: selectedValuesObject = {
    year: new Date().getFullYear().toString(),
  };
  confirmationTypesList: confirmationType[];
  selectedMonth: string;
  selectedConfirmationType: string;
  errorStateYear = false;
  errorTextYear = '';
  showPdfData = true;
  isCompactView = false;
  confirmsDesc: string;
  lastBlob: Blob | null = null;
  confirmsFetchNoError = true;
  confirmsFetchErrorText = '';
  shouldShowErrorBannerForApiFailure = false;
  apiFailureErrorBody = '';
  modelheading = 'All accounts';
  tableheading = 'Confirmation Type';
  showConfirmType = false;
  showdescription = false;
  showpdf = false;
  errorPdfDownload = 'The information is currently unavailable';
  confirmListAllData: confirmObject[] = [];
  confirmsContent: ConfirmationsPageContent;
  viewDropdownContent: any = [];
  dropdownMenuOptions: DropdownMenuData;

  downloadLinkLabel = environment.downloadAccountLink.label
  downloadLinkUrl = environment.downloadAccountLink.url

  isConfirmationStatusUpdate: boolean = false;
  isConfirmationStatusUpdateDelete: boolean = false;
  isViewOfflineConfirmation: boolean = false;


  oktaGroup: OktaGroups = {
    confirmationStatusUpdate: false,
    confirmationStatusUpdateDelete: false,
    viewOfflineConfirmations: false,
  };

  month = '';
  confirmType = '';
  showOptOutButton = false;
  @ViewChild(ModalDialogComponent) modal: { // @ts-ignore
    closeDialogModal: jest.Mock<any, any, any> };
  @ViewChild('errorModal') errorModal: ModalDialogComponent;

  @ViewChild('contentElement') elRef: ElementRef;
  @ViewChild(ModalDialogComponent) confirmationModel: ModalDialogComponent;
  @ViewChild('pdfContainer', { static: false }) pdfContainer!: ElementRef<HTMLDivElement>;
  hideShowMore = true;
  dateSortingState = 'descending';
  descriptionSortingState = 'none';
  confirmTypeSortingState = 'none';
  private modalObserver: MutationObserver | null = null;
  SURVEY_SUBMITTED_KEY = 'medalliaSurveySubmitted';
  private surveyTimeoutId?: number;
  private surveyScheduledTime?: number;

  get storeSelectedConfirms(): Map<string, confirmObject> {
    return this.cache.storeSelectedConfirms;
  }

  constructor(
    private readonly confirmService: ConfirmService,
    private readonly loggerService: LoggerService,
    private readonly caasService: CaasService,
    private readonly changeDetector: ChangeDetectorRef,
    private titleCasePipe: TitleCasePipe,
    private readonly dataTransferService: StatusUpdateDataTransferService,
    private readonly cache: CacheConfirmService,
    private readonly store: Store,
    private readonly router: Router,
    public windowRef: WindowRef,
  ) { }

  async ngOnInit(): Promise<void> {
    this.getCaasData();
    if(environment.internal){
      await this.getOktaGroups();
    }
    this.retrieveData();
    if (environment.internal && environment.FORM_ID) {
      window.addEventListener('neb_OnsiteLoaded', () => {
        KAMPYLE_ONSITE_SDK.loadForm(environment.FORM_ID);
      });
    }
  }

  ngAfterViewInit() {
    this.modalObserver = new MutationObserver(() => {
      const modal = document.querySelector('dialog.c11n-modal-dialog') as HTMLElement;
      const wrapper = document.querySelector('#myCustomModal');
      if (modal && wrapper) {
        modal.style.width = '90vw';
        modal.style.maxWidth = '100vw';
        modal.style.setProperty('--documentMaxWidth', '80vw');
      }
    });
    this.modalObserver.observe(document.body, { childList: true, subtree: true });
  }

  async retrieveData() {
    try {
      for (let i = 1; i < environment.No_OF_YEARS; i++) {
        this.years.push((new Date().getFullYear() - i).toString());
      }
      if (this.cache.isEditEnable && this.cache.cachedYear) {
        this.selectedValues.year = this.cache.cachedYear;
      } else {
        this.selectedValues.year = this.years[0];
      }
      const confirmationTypesArray = await this.getConfirmTypes();
      this.confirmationTypesList = confirmationTypesArray.types;
      await this.getMonthAndConfirms();
      this.cache.isEditEnable = false;
    } catch (err) {
      console.log('inside catch block');
      this.isLoaderIndicator = false;
      this.shouldShowErrorBannerForApiFailure = true;
      this.apiFailureErrorBody = 'Unable to fetch data. Try again later.';
    }

  }

  // eslint-disable-next-line max-statements
  async getMonthAndConfirms() {
    try {
      this.isLoaderIndicator = true;
      this.filterOn = false;
      this.showMoreIndex = 0;
      this.months = [ALL_MONTHS];
      this.confirmationType = [ALL_CONFIRMAION_TYPE];
      this.selectedMonth = ALL_MONTHS;
      this.month = ALL_MONTHS;
      this.confirmType = ALL_CONFIRMAION_TYPE;
      this.selectedConfirmationType = ALL_CONFIRMAION_TYPE;

      if (environment.internal && Array.from(this.cache.masterCache).some(v =>
        new Date(v.endDate).getFullYear().toString() === this.selectedValues.year ||
        moment(v.endDate, 'MM/DD/YYYY').year().toString() === this.selectedValues.year
      )) {
        this.confirmList = Array.from(this.cache.masterCache).filter(v =>
          new Date(v.endDate).getFullYear().toString() === this.selectedValues.year ||
          moment(v.endDate, 'MM/DD/YYYY').year().toString() === this.selectedValues.year
        );
      } else {
        const confirms = await this.getConfirm(this.selectedValues);
        this.confirmList = confirms.confirmations;
      }
      this.confirmList.forEach(confirmsObj => {
        const tempObj = this.confirmationTypesList.find(conf => conf.confirmationTypeCode === confirmsObj.confirmationTypeCode)
        confirmsObj.confirmationEvent = tempObj?.description
      });

      if(environment.internal){
        this.confirmList = this.confirmList.filter(confirm => this.isTrViewable(confirm));
        await this.populateAdditionalConfirmationDetails();
        this.cache.cacheConfirmations = this.confirmList;
        this.confirmList.forEach(v => this.cache.masterCache.add(v));
      }

      if (this.confirmList.length === 0) {
        this.shouldShowErrorBannerForNoData = true;
        this.hideShowMore = true;
      } else {
        this.shouldShowErrorBannerForNoData = false;
      }
      this.confirmList.forEach((cnfrmObj) => {
        cnfrmObj.confirmationDescription = cnfrmObj.confirmationDescription === null ? '' : cnfrmObj.confirmationDescription
        cnfrmObj.endDate = moment(cnfrmObj.endDate).format('MM/DD/YYYY')
        const check = moment(cnfrmObj.endDate, 'MM/DD/YYYY');
        const currentMonth = check.format('MMMM');
        cnfrmObj.month = currentMonth;

        // Set status list based on user roles
        cnfrmObj.statusList = new Set<string>()
        cnfrmObj.statusList.add(AVAILABILITY.ONLINE);
        cnfrmObj.statusList.add(AVAILABILITY.OFFLINE);

        // Only add DELETE option if user has confirmationStatusUpdateDelete role
        if (this.oktaGroup.confirmationStatusUpdateDelete) {
          cnfrmObj.statusList.add(AVAILABILITY.DELETE);
        }

        this.convertListToDropdownMenu(cnfrmObj)
        this.months.push(currentMonth);
        this.confirmationType.push(cnfrmObj.confirmationEvent || '');
      });
      this.months = [...new Set(this.months)];
      this.confirmationType = [...new Set(this.confirmationType)];
      this.months.sort(function (a, b) {
        return environment.ALL_MONTHS.indexOf(a.toUpperCase()) - environment.ALL_MONTHS.indexOf(b.toUpperCase());
      });

      // Restore cached filters when navigating back from status-review
      if (this.cache.isEditEnable) {
        if (this.cache.cachedMonth && this.cache.cachedMonth !== ALL_MONTHS) {
          this.month = this.cache.cachedMonth;
          this.selectedMonth = this.cache.cachedMonth;
        }
        if (this.cache.cachedConfirmType && this.cache.cachedConfirmType !== ALL_CONFIRMAION_TYPE) {
          this.confirmType = this.cache.cachedConfirmType;
          this.selectedConfirmationType = this.cache.cachedConfirmType;
        }
      }

      // sort by date
      this.confirmList.sort((a, b) =>
        moment(a.endDate) > moment(b.endDate) ? -1 : moment(a.endDate) < moment(b.endDate) ? 1 : 0
      );
      this.dateSortingState = 'descending';
      this.confirmTypeSortingState = 'none';
      this.descriptionSortingState = 'none';

      // sort by type on date match
      this.confirmList.sort((a, b) =>
        moment(a.endDate) === moment(b.endDate) ? ((b.confirmationEvent && a.confirmationEvent) ? b.confirmationEvent.localeCompare(a.confirmationEvent) : 0) : 0
      );

      // sort by description where dates and type match
      this.confirmList.sort((a, b) =>
        (a.endDate === b.endDate && a.confirmationEvent === b.confirmationEvent) ? a.confirmationDescription.localeCompare(b.confirmationDescription) : 0
      );
      this.standardConfirmList = this.confirmList;

      // Apply filter if cached filters were restored
      if (this.cache.isEditEnable && (this.month !== ALL_MONTHS || this.confirmType !== ALL_CONFIRMAION_TYPE)) {
        await this.searchConfirms();
      } else {
        this.showMoreConfirms(null);
      }
      this.isLoaderIndicator = false;
      this.isCompactView = this.confirmList.length > 0;
    } catch (err: any) {
      this.shouldShowErrorBannerForNoData = true;
      this.hideShowMore = true;
      this.confirmList = [];
      this.standardConfirmList = [];
      this.isLoaderIndicator = false;
      this.loggerService.error({
        message: err,
        app: PKG.deployment.appPrefix || 'RQF',
      });
      this.confirmsFetchNoError = false;
      this.confirmsFetchErrorText = `${err.status} ${err.statusText}`;
    }
  }



  showMoreConfirms(event) {
    this.showMoreIndex++;
    const totalRecordsToShow = this.showMoreIndex * this.defaultSize;
    const masterList = this.filterOn ? this.filteredMasterConfirmsList : this.confirmList;
    if (totalRecordsToShow < masterList.length) {
      this.standardConfirmList = masterList.slice(0, totalRecordsToShow);
      this.hideShowMore = false;
    } else {
      this.standardConfirmList = masterList;
      this.hideShowMore = true;
    }
    setTimeout(() => {
      this.checkLeftArrowActiveActions('SHOW_MORE');
    }, 300);
    if (event) {
      this.counter++;
      this.changeDetector.detectChanges();
      document.getElementById(`download-icon-${this.counter * this.defaultSize}`)?.focus();
    }
  }
  getCaasData() {
    const pageContent = this.caasService.getPageContent();
    if (pageContent) {
      this.confirmsContent = pageContent;
      this.contentBody = pageContent.errorMessages.noConfirmationsInPeriod;

      // Update error banner config from AEM content
      this.errorBannerConfig.heading = pageContent.errorMessages.systemUnavailableHeading;
      this.errorBannerConfig.body = pageContent.errorMessages.systemUnavailableBody.join(' ');

      // Update heading and table column heading from AEM content
      this.modelheading = pageContent.heading;
      this.tableheading = pageContent.tableSection['confirmationTypeColumnLabel'] || this.tableheading;

      // Update download center link from content
      this.downloadLinkLabel = pageContent.downloadCenterLink?.label || this.downloadLinkLabel;
      this.downloadLinkUrl = pageContent.downloadCenterLink?.url || this.downloadLinkUrl;
    }

    if (!this.confirmsContent) {
      return;
    }

    this.tetriaryNavigationOptions = Object.keys(this.confirmsContent.tabOptions).sort().map(key =>
    ({
      'optionLabel': this.confirmsContent.tabOptions[key].optionLabel,
      'optionUrl': this.confirmsContent.tabOptions[key].optionUrl
    })
    );

    this.viewDropdownContent = Object.keys(this.confirmsContent.dropdownOptions).sort().map(key =>
    ({
      'labelText': this.confirmsContent.dropdownOptions[key].optionLabel,
      'id': this.confirmsContent.dropdownOptions[key].optionUrl ? this.confirmsContent.dropdownOptions[key].optionUrl : '0'
    })
    );

    // Set dropdown options after viewDropdownContent is populated
    this.dropdownMenuOptions = { groups: [{ items: this.viewDropdownContent }] };
  }

  /*eslint complexity: ["error", 10]*/
  /*eslint-env es6*/

  async getSelectedValue(e, type: string) {
    try {
      if (type === 'YEAR') {
        this.selectedValues.year = e.target.options[e.target.options.selectedIndex].text;
        this.checkLeftArrowActiveActions('YEAR_CHANGE');
        await this.getMonthAndConfirms();
      } else if (type === 'MONTH' || type === 'confirmType') {
        // Auto-update table for month and confirmation type changes
        // since data is already loaded for the year
        await this.searchConfirms();
      }
    } catch (err: any) {
      this.isLoaderIndicator = false;
      this.confirmsFetchNoError = false;
      this.confirmsFetchErrorText = `${err.status} ${err.statusText}`;
    }
  }
  trackByFn(index) {
    return index;
  }

  sortColumn(column) {
    const masterList = this.filterOn ? this.filteredMasterConfirmsList : this.confirmList;
    const totalRecordsToShow = this.showMoreIndex * this.defaultSize;
    if (column === 'date') {
      this.dateSort(masterList);
    } else if (column === 'confirmationDescription') {
      this.descriptionSort(masterList, column);
    } else {
      this.confirmationTypeSort(masterList, column);
    }
    this.standardConfirmList = masterList.slice(0, totalRecordsToShow);
  }

  getHighLightCss(confirm: confirmObject): string {
    if ((environment.internal) && (confirm.interestedPartyConfirm ||
      confirm.availabilityStatus?.toLowerCase() === AVAILABILITY.OFFLINE.toLowerCase() ||
      confirm.availabilityStatus?.toLowerCase() === AVAILABILITY.DELETE.toLowerCase()))
      return 'col-internal-highlight-confirm';
    else
      return ''
  }

  private confirmationTypeSort(masterList: confirmObject[], column: string) {
    if (this.confirmTypeSortingState === 'ascending') {
      this.confirmTypeSortingState = 'descending';
      this.dateSortingState = 'none';
      this.descriptionSortingState = 'none';
      masterList.sort((a, b) => b[column].localeCompare(a[column])
      );
      this.standardConfirmList = [...masterList];
    } else {
      this.confirmTypeSortingState = 'ascending';
      this.dateSortingState = 'none';
      this.descriptionSortingState = 'none';
      masterList.sort((a, b) => a[column].localeCompare(b[column])
      );
      this.standardConfirmList = [...masterList];
    }
    setTimeout(() => {
      this.checkLeftArrowActiveActions('SORT');
    }, 300);
  }

  private descriptionSort(masterList: confirmObject[], column: string) {
    if (this.descriptionSortingState === 'ascending') {
      this.descriptionSortingState = 'descending';
      this.dateSortingState = 'none';
      this.confirmTypeSortingState = 'none';
      masterList.sort((a, b) => b[column].localeCompare(a[column])
      );
      this.standardConfirmList = [...masterList];
    } else {
      this.descriptionSortingState = 'ascending';
      this.dateSortingState = 'none';
      this.confirmTypeSortingState = 'none';
      masterList.sort((a, b) => a[column].localeCompare(b[column])
      );
      this.standardConfirmList = [...masterList];
    }
    setTimeout(() => {
      this.checkLeftArrowActiveActions('SORT');
    }, 300);
  }

  private dateSort(masterList: confirmObject[]) {
    if (this.dateSortingState === 'descending') {
      this.dateSortingState = 'ascending';
      this.descriptionSortingState = 'none';
      this.confirmTypeSortingState = 'none';
      masterList.sort((a, b) => moment(a.endDate) < moment(b.endDate) ? -1 : moment(a.endDate) > moment(b.endDate) ? 1 : 0
      );
      this.standardConfirmList = [...masterList];
    } else {
      this.dateSortingState = 'descending';
      this.descriptionSortingState = 'none';
      this.confirmTypeSortingState = 'none';
      masterList.sort((a, b) => moment(a.endDate) > moment(b.endDate) ? -1 : moment(a.endDate) < moment(b.endDate) ? 1 : 0
      );
      this.standardConfirmList = [...masterList];
    }
  }

  // eslint-disable-next-line max-statements
  async searchConfirms() {
    try {
      this.selectedMonth = this.month;
      this.selectedConfirmationType = this.confirmType;
      this.shouldShowErrorBannerForNoData = false;
      this.counter = 0;
      this.confirmsFetchNoError = true;
      if (this.selectedMonth !== ALL_MONTHS) {
        this.showMoreIndex = 0;
        this.filterOn = true;
        this.standardConfirmList = this.confirmList.filter(
          (confirmObj) => confirmObj.month === this.selectedMonth,
        );
        this.filteredMasterConfirmsList = [...this.standardConfirmList];
      } else {
        this.standardConfirmList = this.confirmList;
      }

      if (this.selectedConfirmationType !== ALL_CONFIRMAION_TYPE) {
        this.showMoreIndex = 0;
        this.filterOn = true;
        this.standardConfirmList = this.standardConfirmList.filter(
          (confirmObj) => confirmObj.confirmationEvent === this.selectedConfirmationType,
        );
        this.filteredMasterConfirmsList = [...this.standardConfirmList];
        if (this.standardConfirmList.length === 0) {
          this.shouldShowErrorBannerForNoData = true;
          this.hideShowMore = true;
        }
      }
      if (this.selectedConfirmationType === ALL_CONFIRMAION_TYPE && this.selectedMonth === ALL_MONTHS) {
        this.filterOn = false;
        this.filteredMasterConfirmsList = [];
        this.showMoreIndex = this.showMoreIndex - 1;
        if (this.confirmList.length === 0) {
          this.shouldShowErrorBannerForNoData = true;
          this.hideShowMore = true;
        }
      }
      this.showMoreConfirms(null);
    } catch (err: any) {
      this.confirmsFetchNoError = false;
      this.confirmsFetchErrorText = `${err.status} ${err.statusText}`;
    }
  }

  private getConfirm(searchData: selectedValuesObject): Promise<confirmRes> {
    return this.confirmService.getConfirms(searchData).toPromise();
  }
  private getConfirmTypes(): Promise<confirmationTypeResponse> {
    return this.confirmService.getConfirmTypes().toPromise();
  }
  downloadpdf(pdfURL: string, event) {
    this.isLoaderIndicator = true;
    this.confirmService.downloadPdf(pdfURL).subscribe(
      (data: Blob) => {
        this.isLoaderIndicator = false;
        this.downloadFile(data, 'confirmation.pdf');
        console.log('[Medallia] downloadpdf success — triggering survey');
        this.triggerMedalliaSurvey();
      },
      (error) => {
        this.errorModal.openModalDialog(event)
        this.isLoaderIndicator = false;
        console.error(error);
      },
    );
  }

  ngOnDestroy(): void {
    if (this.surveyTimeoutId) {
      clearTimeout(this.surveyTimeoutId);
    }
  }

  private triggerMedalliaSurvey(): void {
    if (!environment.internal || !environment.FORM_ID) {
      return;
    }
    const currentPoid = (this.windowRef.nativeWindow as any).poid;
    if (currentPoid && environment.MEDALLIA_EXCLUDED_POIDS?.includes(currentPoid)) {
      console.log('Medallia survey skipped: POID is excluded');
      return;
    }

    const now = Date.now();
    if (this.surveyScheduledTime && (now - this.surveyScheduledTime) < environment.SURVEY_DELAY_MS) {
      return;
    }

    if (!this.shouldShowSurvey()) {
      return;
    }

    this.surveyScheduledTime = now;
    const surveyId = environment.FORM_ID;
    this.surveyTimeoutId = window.setTimeout(() => {
      localStorage.setItem(environment.SURVEY_KEY, Date.now().toString());
      KAMPYLE_ONSITE_SDK.showForm(parseInt(surveyId));
      window.addEventListener('MDigital_Form_Close_Submitted', () => {
        localStorage.setItem(this.SURVEY_SUBMITTED_KEY, 'true');
      }, { once: true });
    }, environment.SURVEY_DELAY_MS);
  }

  private shouldShowSurvey(): boolean {
    if (this.wasSurveySubmitted()) return false;
    const lastShown = localStorage.getItem(environment.SURVEY_KEY);
    const durationMs = environment.SURVEY_DURATION_DAYS * 24 * 60 * 60 * 1000;
    if (!lastShown || Date.now() - parseInt(lastShown) > durationMs) {
      return Math.random() < environment.SURVEY_PROBABILITY;
    }
    return false;
  }

  private wasSurveySubmitted(): boolean {
    return localStorage.getItem(this.SURVEY_SUBMITTED_KEY) === 'true';
  }

  downloadFile(response, fileName: string) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    const blob = new Blob([response], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }
  viewRedirect(event) {
    if (event.activeItems[0] !== '0') {
      window.open(event.activeItems[0], "_self");
    }
  }
  viewRedirectOverflow(event) {
    if (event.id) {
      window.open(event.id, "_self");
    }
  }
  keyHandler(event, link) {
    event.stopPropagation();
    this.downloadpdf(link, event);
  }
  closeErrorModal() {
    this.errorModal.closeDialogModal();
  }
  toggleAccountdownload(value: string) {
    this.tableheading = value;
    if (value === this.confirmsContent?.tableSection?.['viewDownloadColumnLabel']) {
      this.showConfirmType = false;
      this.showdescription = false;
      this.showpdf = true;
      this.showPdfData = false;
    } else if (value === this.confirmsContent?.tableSection?.['descriptionColumnLabel']) {
      this.showConfirmType = false;
      this.showdescription = true;
      this.showpdf = false;
      this.showPdfData = true;
    } else if (value === this.confirmsContent?.tableSection?.['confirmationTypeColumnLabel']) {
      this.showConfirmType = true;
      this.showdescription = false;
      this.showpdf = false;
      this.showPdfData = true;
    }
    this.modal.closeDialogModal();
  }

  addRightGradient(element: HTMLElement) {
    const thElements = element.querySelectorAll('th.sticky-right');
    thElements.forEach((item) => item.classList.add(GRADIENT_RIGHT));

    const tdElements = element.querySelectorAll('td.sticky-right');
    tdElements.forEach((item) => item.classList.add(GRADIENT_RIGHT));
  }

  addRightScrollButton(element: HTMLElement) {
    const buttonView = element.querySelector('[data-id="scroll_right"]') as HTMLElement;
    buttonView.hidden = false;
  }

  removeRightGradient(element: HTMLElement) {
    const thElements = element.querySelectorAll('th.sticky-right');
    thElements.forEach((item) => item.classList.remove(GRADIENT_RIGHT));

    const tdElements = element.querySelectorAll('td.sticky-right');
    tdElements.forEach((item) => item.classList.remove(GRADIENT_RIGHT));
  }

  removeRightScrollButton(element: HTMLElement) {
    const buttonView = element.querySelector('[data-id="scroll_right"]') as HTMLElement;
    buttonView.hidden = true;
  }

  addLeftGradient(element: HTMLElement) {
    const thElements = element.querySelectorAll('th.sticky-left');
    thElements.forEach((item) => item.classList.add(GRADIENT_LEFT));

    const tdElements = element.querySelectorAll('td.sticky-left');
    tdElements.forEach((item) => item.classList.add(GRADIENT_LEFT));
  }

  addLeftScrollButton(element: HTMLElement) {
    const buttonView = element.querySelector('[data-id="scroll_left"]') as HTMLElement;
    buttonView.hidden = false;
  }

  removeLeftGradient(element: HTMLElement) {
    const thElements = element.querySelectorAll('th.sticky-left');
    thElements.forEach((item) => item.classList.remove(GRADIENT_LEFT));

    const tdElements = element.querySelectorAll('td.sticky-left');
    tdElements.forEach((item) => item.classList.remove(GRADIENT_LEFT));
  }

  removeLeftScrollButton(element: HTMLElement) {
    const buttonView = element.querySelector('[data-id="scroll_left"]') as HTMLElement;
    buttonView.hidden = true;
  }


  scrollLeft(): void {
    this.elRef.nativeElement.scrollLeft -= SCROLLVALUE;
  }

  scrollRight(): void {
    this.elRef.nativeElement.scrollLeft += SCROLLVALUE;
  }

  onScroll(): void {

    const tableView = this.elRef.nativeElement;
    if (tableView) {
      // table is scrolled all the way to the left or right
      // determine if left/right scroll button/gradients need to be removed
      if (tableView.scrollLeft + tableView.offsetWidth >= tableView.scrollWidth) {
        // scroll is all the way to the right
        this.removeRightScrollButton(tableView);
        this.removeRightGradient(tableView);
        this.addLeftScrollButton(tableView);
        this.addLeftGradient(tableView);
      } else if (tableView.scrollLeft === 0) {
        // scroll is all the way to the left
        this.removeLeftScrollButton(tableView);
        this.removeLeftGradient(tableView);
        this.addRightScrollButton(tableView);
        this.addRightGradient(tableView);
      } else {
        // scroll is in the middle
        this.addLeftScrollButton(tableView);
        this.addLeftGradient(tableView);
        this.addRightScrollButton(tableView);
        this.addRightGradient(tableView);
      }
    }
  }

  keyHandlerView(event: KeyboardEvent, statementId: string, statement: confirmObject): void {
    event.preventDefault();
    this.downloadedpdf(statementId, event, statement);
  }

  keyHandlerPrint(event: KeyboardEvent): void {
    event.preventDefault();
    this.printCurrentPdf();
  }

  async printCurrentPdf() {
    if (!this.lastBlob) return;
    this.logPdfAction('print', { timestamp: new Date().toISOString() });

    // Get all rendered canvases
    const canvases = Array.from(this.pdfContainer.nativeElement.querySelectorAll('canvas'))
      .filter(c => c.width > 0 && c.height > 0);

    const imgs: string[] = canvases.map(c =>
      (c as HTMLCanvasElement).toDataURL('image/png')
    );

    // Create hidden iframe for printing
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);

    const doc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!doc) return;

    doc.open();
    doc.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Print Statement</title>
          <style>
            @page {
              size: landscape;
              margin: 0.5cm;
            }
            @media print {
              html, body {
                width: 100%;
                height: 100%;
                margin: 0;
                padding: 0;
              }
              .page {
                page-break-after: always;
                page-break-inside: avoid;
                width: 100%;
                height: 100vh;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .page:last-child {
                page-break-after: avoid;
              }
              img {
                max-width: 100%;
                max-height: 100%;
                width: auto;
                height: auto;
                object-fit: contain;
              }
            }
          </style>
        </head>
        <body>
    `);

    imgs.forEach((src, index) => {
      doc.write(`<div class="page"><img src="${src}" alt="Page ${index + 1}" /></div>`);
    });

    doc.write('</body></html>');
    doc.close();

    // Trigger print after content loads
    iframe.onload = () => {
      setTimeout(() => {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
      }, 250);
    };

    // Cleanup after printing
    setTimeout(() => {
      if (document.body.contains(iframe)) {
        document.body.removeChild(iframe);
      }
    }, 5000);
  }

  private logPdfAction(action: 'view' | 'print' | 'download', metadata: any): void {
    try {
      this.windowRef.nativeWindow.dataLayer = this.windowRef.nativeWindow.dataLayer || [];
      this.windowRef.nativeWindow.dataLayer.push({
        event: 'pdfAction',
        pdfAction: {
          action,
          timestamp: new Date().toISOString(),
          ...metadata
        }
      });
      this.loggerService.info({
        message: `PDF ${action} action`,
        app: PKG.deployment.appPrefix || 'UJG',
        logCode: `PDF_${action.toUpperCase()}_ACTION`,
        ...metadata
      });
    } catch (error) {
      console.error('Failed to log PDF action:', error);
    }
  }


  private cleanupPdfContainer() {
    if (!this.pdfContainer) return;
    const canvases = this.pdfContainer.nativeElement.querySelectorAll('canvas');
    canvases.forEach((canvas) => {
      const ctx = (canvas as HTMLCanvasElement).getContext('2d');
      if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
    });
    this.pdfContainer.nativeElement.innerHTML = '';
  }

  private async renderPdf(blob: Blob) {
    if (!this.pdfContainer) return;

    // Validate file size and page count
    const fileSizeMB = blob.size / (1024 * 1024);
    if (fileSizeMB > PDF_MAX_SIZE_MB) {
      console.error(`PDF exceeds max size of ${PDF_MAX_SIZE_MB} MB`);
      return;
    }

    this.cleanupPdfContainer();

    // Load PDF document
    const arrayBuffer = await blob.arrayBuffer();
    const pdf = await (pdfjsLib as any).getDocument({ data: new Uint8Array(arrayBuffer) }).promise;

    if (pdf.numPages > PDF_MAX_PAGES) {
      console.error(`PDF exceeds max page limit of ${PDF_MAX_PAGES}`);
      return;
    }
    this.logPdfAction('view', { pages: pdf.numPages, sizeKB: Math.round(blob.size / 1024) });

    // Calculate scale based on container width and device type
    const containerWidth = this.pdfContainer.nativeElement.clientWidth;
    const screenWidth = window.innerWidth;
    const isMobile = screenWidth <= MOBILE_BREAKPOINT;
    const isTablet = screenWidth > MOBILE_BREAKPOINT && screenWidth <= TABLET_BREAKPOINT;

    const firstPage = await pdf.getPage(1);
    const baseViewport = firstPage.getViewport({ scale: 1 });
    let scale = containerWidth / baseViewport.width;

    // Apply device-specific minimum scales for better readability
    if (isMobile) scale = Math.max(scale, MOBILE_SCALE);
    else if (isTablet) scale = Math.max(scale, TABLET_SCALE);
    else scale = Math.max(scale, DESKTOP_SCALE);

    const devicePixelRatio = window.devicePixelRatio || 1;

    // Render all pages
    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const viewport = page.getViewport({ scale });

      // Create canvas
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d')!;
      canvas.width = viewport.width * devicePixelRatio;
      canvas.height = viewport.height * devicePixelRatio;
      canvas.style.width = '100%';
      canvas.style.height = 'auto';
      canvas.style.display = 'block';
      canvas.style.marginBottom = pageNum < pdf.numPages ? PLACEHOLDER_MARGIN_BOTTOM : '0';

      // Render page to canvas
      context.setTransform(devicePixelRatio, 0, 0, devicePixelRatio, 0, 0);
      await page.render({ canvasContext: context, viewport }).promise;

      this.pdfContainer.nativeElement.appendChild(canvas);
    }
  }

  downloadedpdf(statementId: string, event: any, rowData: confirmObject) {
    this.isLoaderIndicator = true;
    this.confirmsDesc = rowData.confirmationDescription;
    this.confirmService.downloadPdf(statementId).subscribe({
      next: (blob: Blob) => {
        this.isLoaderIndicator = false;
        this.lastBlob = blob;
        this.confirmationModel.openModalDialog(event);
        this.triggerMedalliaSurvey();
        setTimeout(() => {
          const active = document.activeElement as HTMLElement;
          active.blur();
        }, 100);
        setTimeout(() => {
          this.renderPdf(blob);
        }, 100);
      },
      error: (err) => {
        this.isLoaderIndicator = false;
        this.loggerService.error({
          message: err,
          app: PKG.deployment.appPrefix || 'UJG',
          logCode: 'Error downloading PDF for view',
        });
        this.errorModal.openModalDialog(event);
      }
    });
  }

  keyHandlerShowMore(event) {
    event.stopPropagation();
    this.showMoreConfirms(event)
  }

  //confirmationStatusUpdate, confirmationStatusUpdateDelete - if one of them true show status column
  isStatusColumnViewable(statement: confirmObject): boolean {
    return this.isConfirmationStatusUpdate || this.isConfirmationStatusUpdateDelete;
  }

  dropDownChangeEvent(e: DropdownState, confirmObject: confirmObject) {
    const newStatus = e.activeItems[0].toUpperCase();
    const currentActive = (confirmObject.temp || confirmObject.availabilityStatus || '').toUpperCase();
    if (newStatus === currentActive) {
      return;
    }
    this.dropDownStatusChanged(newStatus, confirmObject)
  }

  dropDownStatusChanged(selectedStatus: string, selectedConfirms: confirmObject) {
    if (!selectedConfirms)
      return
    if (selectedConfirms.availabilityStatus !== selectedStatus) {
      this.insertConfirmsToCache(selectedConfirms, selectedStatus)
    } else {
      this.cache.storeSelectedConfirms.delete(selectedConfirms.confirmationId)
    }
    selectedConfirms.temp = selectedStatus
  }

  getActiveItems(statement: confirmObject): string {
    return statement.temp || statement.availabilityStatus || '';
  }

  borderOnSelect(confirmObject: confirmObject): boolean {
    if (!confirmObject?.temp)
      return false
    return confirmObject?.availabilityStatus !== confirmObject.temp;
  }

  private insertConfirmsToCache(selectedConfirms: confirmObject, selectedStatus: string) {
    const newVar = this.cache.storeSelectedConfirms.get(selectedConfirms.confirmationId);
    if (newVar) {
      newVar.newStatus = selectedStatus;
    } else {
      selectedConfirms.newStatus = selectedStatus;
      this.cache.storeSelectedConfirms.set(selectedConfirms.confirmationId, selectedConfirms);
    }
  }

  async reviewAndSubmit() {
    if(this.storeSelectedConfirms.size > 9) {
      this.shouldShowErrorBanner = true
      this.errorBannerConfig.size='small'
      this.errorBannerConfig.body='Can not update more than 9 statement.'
      this.errorBannerConfig.type='warning'
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;//do not process
    }

    if(this.storeSelectedConfirms.size === 0) {
      this.shouldShowErrorBanner = true
      this.errorBannerConfig.size='small'
      this.errorBannerConfig.body='Please select at least one confirmation to update.'
      this.errorBannerConfig.type='warning'
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;//do not process
    }

    const confirms = Array.from(this.cache.storeSelectedConfirms.values());
    this.cache.isEditEnable = false;
    this.cache.cachedYear = this.selectedValues.year;
    this.cache.cachedMonth = this.month;
    this.cache.cachedConfirmType = this.confirmType;
    this.dataTransferService.sendData(confirms)
    await this.router.navigate(['/status-review']);
  }

  isStatusColumnDisabled(statement: confirmObject): boolean {
    // Disable dropdown if user doesn't have confirmationStatusUpdate or confirmationStatusUpdateDelete role
    if (!this.oktaGroup.confirmationStatusUpdate && !this.oktaGroup.confirmationStatusUpdateDelete) {
      return true;
    }

    // Disable if statement is already deleted (DELETE or DELE)
    const status = statement.availabilityStatus?.toLowerCase();
    if (status === AVAILABILITY.DELETE.toLowerCase() || status === 'dele') {
      return true;
    }

    return false;
  }

  isDeleteOrDeleStatus(confirmation: confirmObject): boolean {
    const status = confirmation.availabilityStatus?.toLowerCase();
    return status === AVAILABILITY.DELETE.toLowerCase() || status === 'dele';
  }

  convertListToDropdownMenu(confirmObject: confirmObject) {
    const statusList: Set<string | undefined> = confirmObject.statusList || new Set<string>()
    const items: DropdownMenuItem[] = [...statusList].map(value => {
        return {
          'labelText': value?this.titleCasePipe.transform(value):'',
          'id': value,
        }
      }
    );
    confirmObject.statusListDropdown = {groups: [{items: items}]}
  }

  checkLeftArrowActiveActions(action?: string) {
    const el = this.elRef.nativeElement.querySelector('[data-id="scroll_left"]') as HTMLElement;
    if (el && !el.hidden) {
      switch (action) {
        case 'YEAR_CHANGE': {
          this.scrollLeft();
          break;
        }
        case 'SHOW_MORE': {
          this.addLeftGradient(this.elRef.nativeElement);
          break;
        }
        case 'SORT': {
          this.addLeftGradient(this.elRef.nativeElement);
        }
      }
    }
  }

  menuElsEmitterHandler(menuElements: any): void {
    console.log('Menu elements emitted:', menuElements);
    // Handle emitted menu elements
  }

  mySelectItemEventHandler(selectedItem: any): void {
    console.log('Selected item:', selectedItem);
    if (selectedItem.href) {
      window.open(selectedItem.href, selectedItem.targetWindow || '_self');
    } else {
      switch (selectedItem.eventId) {
        case 'holdings':
          console.log('Holdings selected');
          break;
        case 'balances':
          console.log('Balances selected');
          break;
        default:
          console.log('Unknown eventId:', selectedItem.eventId);
      }
    }
  }

  protected readonly environment = environment;


// Internal flow starts heree

  
  onSend(confirmation: confirmObject) {
    console.log('=== onSend DEBUG START ===');
    console.log('onSend method called with confirmation:', confirmation);
    console.log('Confirmation object keys:', Object.keys(confirmation || {}));
    console.log('Current router state before navigation:', this.router.url);

    if (!confirmation) {
      console.log('onSend: No confirmation object provided, returning early');
      return;
    }

    console.log('onSend: Preparing confirmation details for dispatch');
    const confirmationDetails = {
      confirmationId: confirmation.confirmationId ?? '',
      isInterestedParty: confirmation.interestedPartyConfirm ?? false,
      confirmationDate: confirmation.endDate ?? '',
      description: confirmation.confirmationDescription
    };
    this.store.dispatch(setConfirmationDetails(confirmationDetails));
    this.store.dispatch(setStepIndicatorIndex({ stepIndicatorIndex: 1 }));
    this.router.navigate(['/send-confirmation']);
  }

  viewSendOnSpaceOrEnterKeyPress(event, confirmation: confirmObject) {
    event.stopPropagation();
    this.onSend(confirmation)
  }

  private async getOktaGroups(): Promise<void> {
    try {
      const oktaGroupResponse: OktaGroups = await this.confirmService.getOktaGroups()
      if (oktaGroupResponse) {
        this.oktaGroup = oktaGroupResponse;
      }
    } catch (error: any) {
      this.shouldShowErrorBanner = true
      this.errorBannerConfig.size = 'small'
      this.errorBannerConfig.body = 'This page is not showing all the functionality due to a rendering issue.'
      this.errorBannerConfig.variant = 'error'
      this.loggerService.error({
        message: error,
        app: PKG.deployment.appPrefix || 'RQF',
        logCode: 'Error while fetching Okta groups',
      });
    }
  }

  async populateAdditionalConfirmationDetails(): Promise<void>{
    this.isConfirmationStatusUpdate = this.oktaGroup.confirmationStatusUpdate // To update status (Online/Offline only)
    this.isConfirmationStatusUpdateDelete = this.oktaGroup.confirmationStatusUpdateDelete // To update status including Delete
    this.isViewOfflineConfirmation = this.oktaGroup.viewOfflineConfirmations // To view offline confirmations

    this.confirmList.forEach((confirmation) => {
      confirmation.viewOfflineConfirmations = this.oktaGroup.viewOfflineConfirmations;
    });
  }

  isTrViewable(confirm: confirmObject): boolean {
    // Hide offline confirmations if user doesn't have viewOfflineConfirmations role
    if (!this.oktaGroup.viewOfflineConfirmations && confirm.availabilityStatus?.toLowerCase() === AVAILABILITY.OFFLINE.toLowerCase()) {
      return false;
    }

    // Hide deleted confirmations if user doesn't have confirmationStatusUpdateDelete role
    if (!this.oktaGroup.confirmationStatusUpdateDelete && confirm.availabilityStatus?.toLowerCase() === AVAILABILITY.DELETE.toLowerCase()) {
      return false;
    }

    return true;
  }

  colSpan(): number {
    if (this.environment.internal) {
      return (this.isConfirmationStatusUpdate || this.isConfirmationStatusUpdateDelete || this.isViewOfflineConfirmation) ? 9 : 7;
    } else {
      return 5;
    }
  }

  protected readonly AVAILABILITY = AVAILABILITY;
  protected readonly KeyboardEvent = KeyboardEvent;
}
